import script from "./WorkspaceShell.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceShell.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceShell.vue?vue&type=style&index=0&id=0d3c84f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d3c84f0"]])

export default __exports__